import CrudPage from "@/components/admin/CrudPage";

const fields = [
    { name: "name", label: "Ad Soyad", required: true },
    { name: "role", label: "Görev (örn: Başkan, Sayman, Sekreter, Başkan Yardımcısı, Yönetim Kurulu Üyesi)", required: true, fullWidth: true },
    { name: "category", label: "Kategori", type: "select", required: true, options: [
        { value: "baskan", label: "Başkan (sayfa üstünde büyük kart)" },
        { value: "yonetim", label: "Yönetim Kurulu (alttaki grid)" },
    ]},
    { name: "is_divan", label: "Divan Kurulu Üyesi (kartta rozet olarak gözükür)", type: "checkbox" },
    { name: "photo_url", label: "Fotoğraf", type: "image", fullWidth: true },
    { name: "bio", label: "Kısa Biyografi (opsiyonel — sadece Başkan kartında gösterilir)", type: "textarea", fullWidth: true, rows: 3 },
    { name: "order", label: "Sıra (küçük üstte; aynı sırada olanlar Divan üyeleri önce gelir)", type: "number" },
    { name: "active", label: "Aktif", type: "checkbox" },
];

const columns = [
    { key: "photo_url", label: "" },
    { key: "name", label: "Ad Soyad" },
    { key: "role", label: "Görev" },
    { key: "category", label: "Kategori", render: (r) => r.category === "baskan" ? "Başkan" : "Yönetim Kurulu" },
    { key: "is_divan", label: "Divan", render: (r) => r.is_divan ? "✓" : "—" },
    { key: "order", label: "Sıra" },
    { key: "active", label: "Aktif" },
];

const Management = () => (
    <CrudPage
        title="Yönetim Kurulu"
        collection="management_members"
        fields={fields}
        columns={columns}
        defaultValues={{ active: true, category: "yonetim", order: 100, is_divan: false }}
    />
);

export default Management;
